import type { Psfs } from 'bz-core-controls/controls/clinical/psfs';
import Slider from 'bz-core-controls/controls/clinical/slider';
import withDisplayName from 'bz-utilities/hoc/display-name';
import React from 'react';
import { useCallback } from 'react';

interface IProps {
  activity: Psfs;
  readOnly?: boolean;
  removable: boolean;
  removeActivity: (activity: string) => void;
  updateInitialValue: (value: number, activity: string) => void;
}

const ActivityItem = withDisplayName<IProps>((props) => {
  const { activity, readOnly, removeActivity, updateInitialValue, removable } = props;

  const removeOnClick = useCallback(() => {
    removeActivity(activity.activity);
  }, [activity, removeActivity]);

  return (
    <li className="mb-4">
      <div className="relative">
        <div className="my-2 grid grid-cols-[1fr_auto] justify-between gap-4">
          <span className="my-2 text-base text-gray-700">{activity.activity}</span>
          {!readOnly && removable && (
            <button
              disabled={readOnly}
              onClick={removeOnClick}
              className={`relative inline-flex items-center justify-center rounded-full text-red-500 ${
                readOnly ? 'cursor-not-allowed opacity-50' : 'hover:text-red-700'
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>

        <Slider
          min={-1}
          max={10}
          field={activity.activity}
          value={activity.initialValue}
          onChange={updateInitialValue}
          readOnly={readOnly}
          allowNotApplicable={true}
        />
      </div>
    </li>
  );
}, 'ActivityItem');

export default React.memo(ActivityItem);
